import { useLang } from "@/context/LangContext";
import { HERO } from "@/constants/testIds";
import { ArrowRight, MapPin } from "lucide-react";

export default function Hero() {
  const { t } = useLang();

  const goSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="hero"
      data-testid={HERO.section}
      className="relative min-h-[95vh] w-full overflow-hidden flex items-end pt-32 pb-16"
    >
      <img
        src="https://images.unsplash.com/photo-1721338752673-91b7603f2ae0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxjYW55b25pbmclMjBhZHZlbnR1cmV8ZW58MHx8fHwxNzgwODU3OTYyfDA&ixlib=rb-4.1.0&q=85"
        alt="Sustrai Aventura canyoning"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/20" />

      <div className="relative z-10 max-w-[1400px] mx-auto w-full px-6 md:px-10 text-white">
        <div className="flex items-center gap-2 rv-fade-up">
          <MapPin className="w-4 h-4 text-[#F26419]" />
          <span className="text-xs sm:text-sm tracking-[0.3em] uppercase font-bold text-[#F26419]">
            {t("hero.kicker")}
          </span>
        </div>

        <h1 className="font-display font-black text-6xl sm:text-7xl md:text-8xl lg:text-9xl leading-[0.9] tracking-tighter mt-6 rv-fade-up rv-delay-1">
          {t("hero.title.line1")}
          <br />
          <span className="text-[#F26419]">{t("hero.title.line2")}</span>
        </h1>

        <p className="max-w-2xl mt-8 text-lg sm:text-xl leading-relaxed text-white/90 rv-fade-up rv-delay-2">
          {t("hero.subtitle")}
        </p>

        <div className="flex flex-wrap gap-4 mt-10 rv-fade-up rv-delay-3">
          <button
            data-testid={HERO.ctaPrimary}
            onClick={() => goSection("reservar")}
            className="group inline-flex items-center gap-3 bg-[#F26419] hover:bg-[#D95512] text-white font-bold tracking-[0.1em] uppercase px-8 py-5 text-sm transition-colors"
          >
            {t("hero.cta.primary")}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            data-testid={HERO.ctaSecondary}
            onClick={() => goSection("actividades")}
            className="inline-flex items-center gap-3 bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#1A1B1A] font-bold tracking-[0.1em] uppercase px-8 py-5 text-sm transition-colors"
          >
            {t("hero.cta.secondary")}
          </button>
        </div>
      </div>
    </section>
  );
}
